<div class="container{{disabled ? ' disabled' : ''}}" [class.draw-mode]="drawMode" [class.edit-mode]="editMode" [class.drawing]="isDrawingBox">
   <div class="image-wrapper" #imageContainer [ngClass]="aspectClass" [style.--ratio]="imageRatio">
      <img [src]="imageUrl" #imageRef class="image"
         (click)="onCanvasClick($event)"
         (pointerdown)="onCanvasPointerDown($event)"
         (load)="onImageLoad()"/>

      <lib-button
         *ngIf="isMobile && !hideTools && !readOnly"
         icon="add"
         class="draw-btn"
         [color]="drawMode ? 'primary' : 'muted'"
         (click)="toggleDrawMode()">
      </lib-button>
      <lib-button
         *ngIf="isMobile && !hideTools && !readOnly"
         icon="edit"
         class="edit"
         [color]="editMode ? 'primary' : 'muted'"
         (click)="toggleEditMode()">
      </lib-button>

      <div *ngFor="let b of boxes; let i = index; trackBy: trackByIndex"
         #boxEl
         class="box"
         [class.active]="i === activeIndex"
         [class.ai]="b.ai"
         [style.borderColor]="b.color || 'red'"
         [style.left.%]="b.box.left * 100"
         [style.top.%]="b.box.top * 100"
         [style.width.%]="b.box.width * 100"
         [style.height.%]="b.box.height * 100"
         (pointerdown)="onBoxPointerDown($event, i)"
         (pointerenter)="onBoxPointerEnter($event, i)"
         (pointerleave)="onBoxPointerLeave($event, i)"
         (click)="onBoxClick($event)"
         (contextmenu)="onBoxOpen($event, i)">

         <span *ngIf="b.label" class="box-tag-name">{{ b.label }}</span>

         <ng-container *ngIf="canEditGeometry && i === activeIndex">
            <div class="resize tl" (pointerdown)="onResizePointerDown($event, i, 'tl')"></div>
            <div class="resize tr" (pointerdown)="onResizePointerDown($event, i, 'tr')"></div>
            <div class="resize bl" (pointerdown)="onResizePointerDown($event, i, 'bl')"></div>
            <div class="resize br" (pointerdown)="onResizePointerDown($event, i, 'br')"></div>
         </ng-container>
      </div>

      <div *ngIf="pending"
         class="box pending"
         [style.borderColor]="pendingLabel?.color || null"
         [style.left.%]="pending.left * 100"
         [style.top.%]="pending.top * 100"
         [style.width.%]="pending.width * 100"
         [style.height.%]="pending.height * 100">
         <span *ngIf="pendingLabel?.label" class="box-tag-name">{{ pendingLabel?.label }}</span>
      </div>
   </div>
</div>
